import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex);

import { secure } from './modules/secure/secure'
import { order } from './modules/order/order'
import { orderItems } from './modules/order/order-items'
import { orderServices } from './modules/order/order-services'
import { orderCheckout } from './modules/order/order-checkout'

import { orderStorageCloset } from './modules/storage/order-storage-closet'
import { orderMovingCloset } from './modules/moving/order-moving-closet'
import { orderMovingPackages } from './modules/moving/order-moving-packages'
import { orderPartnersCloset } from './modules/partners/order-partners-closet'
import { orderPartnersPackages } from './modules/partners/order-partners-packages'

export const store = new Vuex.Store({
  modules: {
    secure,
    order,
    orderItems,
    orderServices,
    orderCheckout,
    orderStorageCloset,
    orderMovingCloset,
    orderMovingPackages,
    orderPartnersCloset,
    orderPartnersPackages
  }
})
